// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64b4e15d","627":"e5355ac6","653":"0b1a04aa","738":"eaec8d0e","923":"8835c135"}[chunkId] + ".chunk.js";
};